export var EmailMarketingProvider;
(function (EmailMarketingProvider) {
    EmailMarketingProvider["Mailchimp"] = "Mailchimp";
    EmailMarketingProvider["ConstantContact"] = "ConstantContact";
})(EmailMarketingProvider || (EmailMarketingProvider = {}));
//# sourceMappingURL=audience.js.map